import { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row } from 'react-bootstrap'
import LabelCustomSmall from '../../label-custom-small'
import ImgUser from '../../../images/user.png'
import { createTransferAPI, getTransferAPI } from '../../../services/transfer'
import { useOutletContext, useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { Controller, useForm } from 'react-hook-form'
import Autocomplete from '../../custom/autocomplete'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import UseGroups from '../../../hooks/use-groups'
import UseTeams from '../../../hooks/use-teams'
import UseDepartments from '../../../hooks/use-departments'
import UsePositions from '../../../hooks/use-position'
import UseFactions from '../../../hooks/use-factions'
import DatepickerCustom from '../../datepicker-custom'
import EmployeeImg from '../../../images/Employee.svg'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../error/error-false'
import { useSelector } from 'react-redux'
import ImageLoading from '../../../images/loading.svg'
import UseEmpsTypes from '../../../hooks/use-emps-types'

export default function DetailEmployeePromote() {
  const [getFnData] = useOutletContext()
  const [isLoading, setIsLoading] = useState(false)
  const roleId = useSelector((state) => state.roleReducer.role)

  let [searchParams, setSearchParams] = useSearchParams()

  const uuid = searchParams.get('uuid')

  const schema = yup
    .object({
      divisions: yup.object().required('กรุณาระบุสายงาน'),
      department: yup.object().required('กรุณาระบุแผนก'),
      faction: yup.object().required('กรุณาระบุฝ่าย'),
      team: yup.object().required('กรุณาระบุทีม'),
      position: yup.object().required('กรุณาระบุตำแหน่ง'),
      level_id: yup.string().required('กรุณาระบุเลเวล'),
      employeeTypes: yup.object().required('กรุณาระบุประเภทพนักงาน'),
      endDate: yup.string().required('กรุณาระบุวันที่พ้น')
    })
    .required()
  const [data, setData] = useState()
  const [divisionId, setDivisionId] = useState(0)
  const [factionId, setFactionId] = useState(0)
  const [departmentId, setDepartmentId] = useState(0)
  const [teamId, setTeamId] = useState(0)
  const [orgId, setOrgId] = useState()
  const [isSave, setIsSave] = useState(false)
  const [isPreload, setIsPreload] = useState(false)

  const [isLoad, setIsLoad] = useState(false)
  const divisions = UseGroups(orgId) //สายงาน
  const factions = UseFactions(
    orgId,
    divisionId,
    factionId,
    departmentId,
    undefined,
    isPreload
  ) //ฝ่าย
  const department = UseDepartments(
    orgId,
    divisionId,
    factionId,
    departmentId,
    isPreload
  ) //แผนก
  const teams = UseTeams(orgId, divisionId, departmentId) //ทีม
  const positions = UsePositions(orgId, divisionId, departmentId, teamId) //ตำแน่ง
  const employeeTypes = UseEmpsTypes() //ประเภทพนักงาน

  const {
    control,
    setValue,
    setError,
    reset,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    const getTransfer = async () => {
      setIsLoading(true)
      const res = await getTransferAPI({ uuid })
      setIsLoading(false)
      if (!res) return
      if (res.status) {
        const d = res.result
        setData(d)
        setOrgId(d.org_id)
        console.log('d', d)

        // ✅ setValue ทันทีจาก API response ก่อนที่ hooks จะโหลด options
        if (d.ds_id)
          setValue('divisions', {
            value: d.ds_id,
            label: d.division_name
          })
        if (d.fac_id)
          setValue('faction', {
            value: d.fac_id,
            label: d.faction_name
          })
        if (d.dm_id)
          setValue('department', {
            value: d.dm_id,
            label: d.department_name
          })
        if (d.team_id)
          setValue('team', { value: d.team_id, label: d.team_name || '' })
        if (d.position_id)
          setValue('position', {
            value: d.position_id,
            label: d.position_name || ''
          })
        if (d.level_id) setValue('level_id', d.level_id)
        if (d.type_id)
          setValue('employeeTypes', {
            value: d.type_id,
            label: d.type_name || ''
          })

        // ✅ set state IDs เพื่อให้ hooks ดึง options มา
        setDivisionId(d.ds_id)
        setFactionId(d.fac_id)
        setDepartmentId(d.dm_id)
        setTeamId(d.team_id)
        setIsPreload(true)
      }
    }
    if (uuid) {
      reset()
      getTransfer()
    }
  }, [uuid, isLoad])

  // useEffect(() => {
  //   if (!data || !divisions.length) return
  //   const found = divisions.find((o) => o.value === data.ds_id)
  //   if (found) setValue('divisions', found)
  // }, [divisions, data])

  // useEffect(() => {
  //   if (!data || !factions.length) return
  //   const found = factions.find((o) => o.value === data.fac_id)
  //   if (found) {
  //     setValue('faction', found)
  //     setIsPreload(false)
  //   }
  // }, [factions, data])

  // useEffect(() => {
  //   if (!data || !department.length) return
  //   const found = department.find((o) => o.value === data.dm_id)
  //   if (found) setValue('department', found)
  // }, [department, data])

  // teams โหลดเสร็จ → setValue
  // useEffect(() => {
  //   if (!data || !teams.length) return
  //   const found = teams.find((o) => o.value === data.team_id)
  //   if (found) setValue('team', found)
  // }, [teams, data])

  // positions โหลดเสร็จ → setValue
  // useEffect(() => {
  //   if (!data || !positions.length) return
  //   const found = positions.find((o) => o.value === data.position_id)
  //   if (found) {
  //     setValue('position', found)
  //     setValue('level_id', found.level_id ?? data.level_id)
  //   }
  // }, [positions, data])

  // employeeTypes โหลดเสร็จ → setValue
  useEffect(() => {
    if (!data || !employeeTypes.length) return
    const found = employeeTypes.find((o) => o.value === data.type_id)
    if (found) setValue('employeeTypes', found)
  }, [employeeTypes, data])

  const onSubmit = (data) => {
    const d = data
    const body = {
      orgId: orgId,
      uuid: uuid,
      dsId: d.divisions?.value,
      facId: d.faction.value,
      dmId: d.department?.value,
      teamId: d.team.value,
      positionId: d.position.value,
      typeId: d.employeeTypes?.value,
      effectiveDate: d.endDate
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createTransfer(body)
      }
    })
  }

  const createTransfer = async (body) => {
    const res = await createTransferAPI(body)
    setIsSave(false)
    if (!res) return
    if (res.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setSearchParams({})
        getFnData()
      })
      setIsLoad(true)
    } else {
      Error_false(res)
    }
  }

  return isLoading ? (
    <div className="text-center">
      <Image src={ImageLoading} fluid />
    </div>
  ) : (
    <>
      {uuid ? (
        <>
          <Form
            id="transferEmp"
            className="p-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* {isLoading && <div className="preloader"></div>} */}

            <Row
              className="border-bottom pb-3 pt-3 position-sticky bg-white mb-4"
              style={{ top: 0 }}
            >
              <Col
                xl={12}
                className="d-flex justify-content-between fw-light small"
              >
                <div className="d-flex ">
                  <Image
                    fluid
                    className="rounded-circle "
                    style={{ maxWidth: 60, maxHeight: 60, objectFit: 'cover' }}
                    src={data?.img_url || ImgUser}
                    onError={(event) => {
                      event.target.src = ImgUser
                      event.onerror = null
                    }}
                  />
                  <div className="ms-3 my-auto">
                    <p
                      className="mb-2 box-text-1"
                      style={{
                        fontSize: 14
                      }}
                    >
                      {`${data?.title_en || '-'} ${data?.name_en || '-'} ${
                        data?.surname_en || '-'
                      }`}
                    </p>
                    <p
                      className="mb-0 box-text-1"
                      style={{
                        fontSize: 12
                      }}
                    >
                      {`${data?.title_th || '-'}${data?.name_th || '-'} ${
                        data?.surname_th || '-'
                      } (${data?.nickname_th || '-'})`}
                    </p>
                  </div>
                </div>

                <div className="my-auto">
                  <p
                    className="mb-2 box-text-1"
                    style={{
                      fontSize: 14
                    }}
                  >
                    {`${
                      data?.start_date
                        ? moment(data.start_date).format('DD MMMM YYYY')
                        : '-'
                    } ( ${data?.date_applied_job} )`}
                  </p>
                  <p
                    className="mb-0 box-text-1"
                    style={{
                      fontSize: 12
                    }}
                  >
                    {`${data?.shift || '-'} (${
                      data?.start_time
                        ? moment(data.start_time, 'HH:mm:ss').format('HH:mm')
                        : '-'
                    } - ${
                      data?.end_time
                        ? moment(data.end_time, 'HH:mm:ss').format('HH:mm')
                        : '-'
                    }) `}
                  </p>
                </div>
                <div className="my-auto">
                  <p
                    className="mb-2 box-text-1"
                    style={{
                      fontSize: 14
                    }}
                  >
                    {data?.email || '-'}
                  </p>
                  <p
                    className="mb-0 box-text-1"
                    style={{
                      fontSize: 12
                    }}
                  >
                    {data?.phone || '-'}
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="g-3">
              <ColFrom>
                <LabelCustomSmall>01 สายงาน</LabelCustomSmall>

                <Controller
                  name={'divisions'}
                  control={control}
                  render={({ field: { value = null } }) => (
                    <Autocomplete
                      value={value}
                      options={divisions}
                      onChange={(res) => {
                        setError('divisions', res)
                        setValue('divisions', res)

                        setValue('faction', null)
                        setValue('department', null)
                        setValue('team', null)
                        setValue('position', null)
                        setValue('level_id', 0)

                        setDivisionId(res.value + '')
                        setFactionId(0)
                        setDepartmentId(0)
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.divisions?.message && (
                  <label className="small text-danger">
                    {errors.divisions.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>02 ฝ่าย</LabelCustomSmall>
                <Controller
                  name={'faction'}
                  control={control}
                  render={({ field: { value = null } }) => (
                    <Autocomplete
                      disabled={divisionId > 0 ? false : true}
                      value={value}
                      options={factions}
                      onChange={(res) => {
                        setError('faction', res)
                        setValue('faction', res)

                        setValue('department', null)
                        setValue('team', null)
                        setValue('position', null)
                        setValue('level_id', 0)

                        setFactionId(res.value)

                        setDepartmentId(0)
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.faction?.message && (
                  <label className="small text-danger">
                    {errors.faction.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>03 แผนก</LabelCustomSmall>
                <Controller
                  name={'department'}
                  control={control}
                  render={({ field: { value = null } }) => (
                    <Autocomplete
                      value={value}
                      disabled={factionId > 0 ? false : true}
                      options={department}
                      onChange={(res) => {
                        setDepartmentId(res.value)
                        setError('department', res)
                        setValue('department', res)
                        setValue('team', null)
                        setValue('position', null)
                        setValue('level_id', 0)
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.department?.message && (
                  <label className="small text-danger">
                    {errors.department.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>04 ทีม</LabelCustomSmall>
                <Controller
                  name={'team'}
                  control={control}
                  render={({ field: { value = null } }) => (
                    <Autocomplete
                      value={value}
                      disabled={departmentId > 0 ? false : true}
                      options={teams}
                      onChange={(res) => {
                        setTeamId(res.value)
                        setValue('team', res)
                        setError('team', res)

                        setValue('position')
                        setValue('level_id', 0)
                      }}
                    />
                  )}
                />
                {errors.team?.message && (
                  <label className="small text-danger">
                    {errors.team.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>05 ตำแหน่ง</LabelCustomSmall>
                <Controller
                  name={'position'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      disabled={teamId > 0 ? false : true}
                      options={positions}
                      onChange={(res) => {
                        setValue('position', res)
                        setError('position', res)
                        setValue('level_id', res.level_id)
                        setError('level_id', res.level_id)
                      }}
                    />
                  )}
                />
                {errors.position?.message && (
                  <label className="small text-danger">
                    {errors.position.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>06 ประเภทพนักงาน</LabelCustomSmall>
                <Controller
                  name={'employeeTypes'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      disabled={teamId > 0 ? false : true}
                      options={employeeTypes}
                      onChange={(res) => {
                        setValue('employeeTypes', res)
                        setError('employeeTypes', res)
                      }}
                    />
                  )}
                />
                {errors.employeeTypes?.message && (
                  <label className="small text-danger">
                    {errors.employeeTypes.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>07 Level</LabelCustomSmall>
                <Controller
                  name={'level_id'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Form.Control readOnly value={value} onChange={onChange} />
                  )}
                />
                {errors.position?.message && (
                  <label className="small text-danger">
                    {errors.position.message}
                  </label>
                )}
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall>08 วันที่มีผล</LabelCustomSmall>
                <Controller
                  name={'endDate'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <DatepickerCustom
                      value={value}
                      onChange={([date]) => {
                        onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                        setValue(
                          'endDate',
                          date ? moment(date).format('YYYY-MM-DD') : ''
                        )
                      }}
                    />
                  )}
                />
                {errors.endDate?.message && (
                  <label className="small text-danger">
                    {errors.endDate.message}
                  </label>
                )}
              </ColFrom>
            </Row>
          </Form>

          <div className="m-5 d-flex justify-content-center">
            <Button
              // style={{
              //   width: 200
              // }}
              disabled={isSave}
              className="px-5"
              type="submit"
              form="transferEmp"
              // onClick={()=>{onSubmit(data)}}
            >
              Promot{isSave ? 'ing...' : 'e'}
            </Button>
          </div>
        </>
      ) : (
        <>
          <div
            className="d-flex justify-content-center"
            style={{
              paddingTop: 200,
              paddingBotton: 200
            }}
          >
            <Image src={EmployeeImg} width={200} />
          </div>
          {roleId ? (
            <p
              className="text-secondary text-center fw-bold mt-2 pe-3 pl-3"
              style={{
                opacity: 0.5,
                fontSize: 20
              }}
            >
              Please Select The Employee To Be Transferred.
            </p>
          ) : (
            <p
              className="text-secondary text-center fw-bold mt-2 pe-3 pl-3"
              style={{
                opacity: 0.5,
                fontSize: 20
              }}
            >
              - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
            </p>
          )}
        </>
      )}
    </>
  )
}
const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={4} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
